import { useRouteError } from "react-router-dom";

import {
  MembershipLimitReached,
  MissingAccount,
  NotFound,
  UnexpectedError,
} from "@/components/errors";
import useForbiddenError from "@/modules/auth/hooks/use-forbidden-error";
import { MissingAccountError, NotFoundError } from "@/modules/errors";
import { MembershipLimitError } from "@/services/lukita/errors";

export default function ApplicationError() {
  let error = useRouteError();
  useForbiddenError();

  if (error instanceof NotFoundError) {
    return <NotFound error={error} />;
  }

  if (error instanceof MissingAccountError) {
    return <MissingAccount />;
  }

  if (error instanceof MembershipLimitError) {
    return <MembershipLimitReached />;
  }
  console.error(error);
  return <UnexpectedError error={error} />;
}
